// extracted by mini-css-extract-plugin
export default {"BookingInfoWrapper":"bookingInfo_BookingInfoWrapper_NpsN4","HeaderWrapper":"bookingInfo_HeaderWrapper_hbdaB"};